<div [formGroup]="formGroup" class="pure-g">
  <!-- Currency -->
  <div class="pure-u-1 p-b-16">
    <mc-select
      ngDefaultControl
      label="Currency"
      formControlName="currency"
      [attr.invalid]="isControlInErrorState(formGroup.controls['currency'])"
      fit="small"
      required>
      @for (currency of currencyList; track currency.currencyCode) {
        <mc-option [value]="currency.currencyCode">{{ currency.currencyCode }} - {{ currency.currencyName }}</mc-option>
      }
      @if (formGroup.get('currency')?.hasError('required')) {
        <span slot="errormessage">Currency is required</span>
      }
    </mc-select>
  </div>
  <!-- Vendor Code implementation is currently not visible in UI as per Ganesh's advice.
    <div class="pure-u-1 p-b-16">
        <mc-input 
            ngDefaultControl
            label="Vendor Code"
            formControlName="vendorCode"
            [attr.invalid]="isControlInErrorState(formGroup.controls['vendorCode'])"
            fit="small"
            required>
            @if(formGroup.get('vendorCode')?.hasError('required')){
                <span slot="errormessage">Vendor Code is required</span>
            }
            @else if(formGroup.get('vendorCode')?.hasError('minlength') || formGroup.get('vendorCode')?.hasError('maxlength')){
                <span slot="errormessage">Vendor Code must be exactly 6 characters</span>
            }
            @else if(formGroup.get('vendorCode')?.hasError('pattern')){
                <span slot="errormessage">Vendor Code must be alphanumeric only</span>
            }
        </mc-input>
    </div>
    -->

  <!-- Link to Accounting -->
  <div class="pure-u-1 p-b-16">
    <mc-select ngDefaultControl formControlName="linkToAccounting" fit="small">
      <span slot="label">Link to Accounting <span class="mds-neutral--weak__text-color">(Optional)</span></span>
      @for (option of linkToAccountingOptions; track option) {
        <mc-option [value]="option">{{ option }}</mc-option>
      }
    </mc-select>
  </div>
</div>
